<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form
        :model="state"
        label-width="auto"
        ref="formDom"
        :scroll-to-error="true"
      >
        <div
          v-for="(model, index) in state.employee_list"
          :key="model"
          class="payroll-edits-box"
        >
          <ul
            style="
              border-bottom: 1px solid #eeeaea;
              font-size: 18px;
              font-weight: 600;
              padding-bottom: 5px;
              height: 30px;
            "
          >
            {{
              model.name || "个人信息"
            }}
          </ul>
          <ul class="payroll-edits-box-ul">
            <el-form-item label="状态">
              <el-switch
                v-model="model.status"
                inline-prompt
                active-text="启用"
                active-color="#1e90ff"
                inactive-text="停用"
                inactive-color="#f00"
                :active-value="1"
                :inactive-value="0"
              />
            </el-form-item>
            <el-form-item
              label="姓名"
              :prop="`employee_list[${index}][name]`"
              :rules="[
                { required: true, message: '请填写员工姓名', trigger: 'blur' },
              ]"
            >
              <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item
              label="手机号"
              :prop="`employee_list[${index}][phone]`"
              :rules="[
                {
                  required: true,
                  message: '请填写员工手机号',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="model.phone"></el-input>
            </el-form-item>
            <el-form-item
              label="证件类型"
              :prop="`employee_list[${index}][idtype]`"
              :rules="[
                {
                  required: true,
                  message: '请选择证件类型',
                  trigger: 'blur',
                },
              ]"
            >
              <el-select v-model="model.idtype">
                <el-option
                  v-for="item in state.idTypeData"
                  :key="item"
                  :label="item.name"
                  :value="item.name"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadIdType()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              label="证件号"
              :prop="`employee_list[${index}][idtype]`"
              :rules="[
                {
                  required: true,
                  message: '请填写证件号',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="model.idcard"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="model.sex">
                <el-radio value="男">男</el-radio>
                <el-radio value="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </ul>
          <ul
            style="
              border-bottom: 1px solid #eeeaea;
              font-size: 12px;
              font-weight: 600;
              padding-bottom: 5px;
            "
          >
            申报信息
          </ul>
          <ul class="payroll-edits-box-ul">
            <el-form-item label="在职状态">
              <el-switch
                v-model="model.application_unit.status"
                inline-prompt
                active-text="在职"
                active-color="#1e90ff"
                inactive-text="离职"
                inactive-color="#f00"
                :active-value="1"
                :inactive-value="0"
                style="--el-switch-off-color: #f00"
              />
            </el-form-item>
            <el-form-item label="属性">
              <el-radio-group v-model="model.application_unit.property">
                <el-radio :label="0">雇员</el-radio>
                <el-radio :label="1">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="扣缴义务人类型"
              :prop="`employee_list[${index}][application_unit][withholding_agent_type]`"
              :rules="[
                {
                  required: true,
                  message: '请选择扣缴义务人类型',
                  trigger: 'blur',
                },
              ]"
            >
              <el-radio-group
                v-model="model.application_unit.withholding_agent_type"
                @change="onTypeChange"
              >
                <el-radio :label="0">扣缴义务人</el-radio>
                <el-radio :label="1">供应商</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="model.application_unit.withholding_agent_type == 0"
              label="扣缴义务人"
              :prop="`employee_list[${index}][application_unit][withholding_agent_id]`"
              :rules="[
                {
                  required: true,
                  message: '请选择扣缴义务人',
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                v-model="model.application_unit.withholding_agent_id"
                placeholder="--选择扣缴义务人--"
              >
                <el-option label="--请选择--" :value="0" />
                <el-option
                  v-for="item in state.withholding_agent"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadWithholdingAgent()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="model.application_unit.withholding_agent_type == 1"
              label="供应商"
              :prop="`employee_list[${index}][application_unit][withholding_agent_id]`"
              :rules="[
                {
                  required: true,
                  message: '请选择供应商',
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                v-model="model.application_unit.withholding_agent_id"
                placeholder="--供应商--"
                @change="onSupplierChange($event, model)"
              >
                <el-option label="--请选择--" :value="0" />
                <el-option
                  v-for="item in state.supplier"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadSupplier()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              label="结算单位"
              :prop="`employee_list[${index}][application_unit][settle_unit_id]`"
              v-if="model.application_unit.withholding_agent_type == 1"
              :rules="[
                { required: true, message: '请选择结算单位', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (!value) {
                      callback(new Error('请选择结算单位'));
                    } else {
                      callback();
                    }
                  },
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                v-model="model.application_unit.settle_unit_id"
                placeholder="--选择结算单位--"
              >
                <el-option label="--请选择--" :value="0" />
                <el-option
                  v-for="item in model.application_unit.settleunitData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadSettleUnit()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="签约单位">
              <el-select
                v-model="model.application_unit.contract_unit_id"
                placeholder="--选择签约单位--"
                @clear="delete model.application_unit.contract_unit_id"
              >
                <el-option
                  v-for="item in state.contract_unit"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
                <template #footer>
                  <el-button size="small" @click="onLoadContractUnit()">
                    刷新
                  </el-button>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item
              label="税款所属期"
              :prop="`employee_list[${index}][application_unit][skssq]`"
              :rules="[
                {
                  required: true,
                  message: '请选择税款所属期',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="model.application_unit.skssq"
                type="month"
                placeholder="--税款所属期--"
                value-format="YYYY-MM"
                format="YYYY年M月"
              />
            </el-form-item>
            <el-form-item label="入职时间">
              <el-date-picker
                v-model="model.application_unit.entry_time"
                type="date"
                placeholder="--入职时间--"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
            <el-form-item label="离职时间">
              <el-date-picker
                v-model="model.application_unit.resignation_time"
                type="date"
                placeholder="--离职时间--"
                value-format="YYYY-MM-DD"
              />
            </el-form-item>
            <el-form-item label="所属客服">
              <el-input v-model="model.application_unit.username" disabled>
                <template #prefix>{{
                  $store.state?.loginUser?.name +
                  "/" +
                  $store.state?.loginUser?.department_name
                }}</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="服务费承担方式"
              :prop="`employee_list[${index}][application_unit][service_cost_mode]`"
              :rules="[
                {
                  required: true,
                  message: '请选择服务费承担方式',
                  trigger: 'blur',
                },
              ]"
            >
              <el-radio-group
                v-model="model.application_unit.service_cost_mode"
              >
                <el-radio-button :value="0">员工</el-radio-button>
                <el-radio-button :value="1">公司</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="其他情况说明"
              :prop="`employee_list[${index}][application_unit][qtqksm]`"
              :rules="[
                {
                  required: model.application_unit.property == 1,
                  message: '请选择其他情况说明',
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                v-model="model.application_unit.qtqksm"
                placeholder="其他情况说明"
                size="large"
              >
                <el-option
                  label="扣缴申报利息股息红利所得"
                  value="扣缴申报利息股息红利所得"
                />
                <el-option label="扣缴申报偶然所得" value="扣缴申报偶然所得" />
                <el-option label="申报其他所得" value="申报其他所得" />
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="model.bz"
                :autosize="{ minRows: 1 }"
              />
            </el-form-item>
            <el-form-item label="服务费计算方式" style="width: 66.66%">
              <div style="display: flex; align-items: center">
                <el-config-provider
                  :value-on-clear="null"
                  :empty-values="[undefined, null]"
                >
                  <el-select
                    v-model="model.application_unit.service_cost_calc_mode"
                    placeholder="计算基数"
                    style="width: 200px"
                    @clear="model.application_unit.service_cost_calc_mode = 0"
                  >
                    <el-option label="无" :value="0" />
                    <el-option label="应发工资" :value="1" />
                    <el-option label="应发工资-代扣项目" :value="2" />
                  </el-select>
                  <el-input-number
                    v-model="model.application_unit.service_cost_calc_rate"
                    :controls="false"
                    class="number-input-left number-input-suffix"
                    :precision="2"
                    suffix="%"
                    style="width: 100px; margin-left: 5px"
                  ></el-input-number>
                  <el-select
                    v-model="model.application_unit.service_cost_type"
                    placeholder="收费类型"
                    style="width: 120px; margin-left: 5px"
                    @clear="model.application_unit.service_cost_type = 0"
                  >
                    <el-option label="无" :value="0" />
                    <el-option label="每人每月" :value="1" />
                    <el-option label="每人每笔" :value="2" />
                  </el-select>
                  <el-input-number
                    v-model="model.application_unit.service_cost"
                    :controls="false"
                    class="number-input-left number-input-suffix"
                    :precision="2"
                    suffix="元"
                    style="width: 100px; margin-left: 5px"
                  ></el-input-number>
                </el-config-provider>
              </div>
            </el-form-item>
          </ul>
          <ul
            style="
              border-bottom: 1px solid #eeeaea;
              font-size: 12px;
              font-weight: 600;
              padding-bottom: 5px;
            "
          >
            收款信息
          </ul>
          <ul class="payroll-edits-box-ul">
            <el-form-item
              label="开户行"
              :prop="`employee_list[${index}][application_unit][opening_bank]`"
              :rules="[
                { required: true, message: '请填写开户行', trigger: 'blur' },
              ]"
            >
              <el-input v-model="model.application_unit.opening_bank" />
            </el-form-item>
            <el-form-item
              label="银行卡号"
              :prop="`employee_list[${index}][application_unit][bank_account]`"
              :rules="[
                { required: true, message: '请填写银行卡号', trigger: 'blur' },
              ]"
            >
              <el-input v-model="model.application_unit.bank_account" />
            </el-form-item>
            <el-form-item label="异卡发放" style="width: 40%">
              <el-switch
                v-model="model.application_unit.is_diff_bank"
                inline-prompt
                :active-value="1"
                :inactive-value="0"
              />
              <text style="color: #f00; margin-left: 20px">
                注：异卡发放需财务审核后才生效
              </text>
            </el-form-item>
            <el-form-item
              v-if="model.application_unit.is_diff_bank"
              label="户名"
              :prop="`employee_list[${index}][application_unit][bank_account_name]`"
              :rules="[
                {
                  required: model.application_unit.is_diff_bank,
                  message: '请填写户名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input v-model="model.application_unit.bank_account_name" />
            </el-form-item>
          </ul>
        </div>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  payrollemployee_getbyid,
  payrollemployee_editbatch,
} from "@/http/payrollemployee";
import { idtype_select } from "@/http/dictionary";
import { data_settleunit_select } from "@/http/data";
import { ElMessage } from "element-plus";
export default {
  props: {
    payroll_id: Number,
    ids: Array,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadIdType();
      payrollemployee_getbyid({
        payroll_id: props.payroll_id,
        id: props.ids.join(","),
      }).then((res) => {
        if (res.status == 200) {
          const { employee_list, withholding_agent, supplier, contract_unit } =
            res.data.data;
          state.employee_list = employee_list;

          state.employee_list.forEach((e) => {
            const skssq = e.application_unit.skssq.toString();
            if (skssq.length == 6)
              e.application_unit.skssq =
                skssq.substring(0, 4) + "-" + skssq.substring(4, 6);
            else delete e.application_unit.skssq;
          });
          state.withholding_agent = withholding_agent;
          state.supplier = supplier;
          state.contract_unit = contract_unit;
          state.key = Math.random();
        }
      });
    });

    //获取证件类型
    const onLoadIdType = () => {
      idtype_select().then((res) => {
        if (res.status == 200) {
          state.idTypeData = res.data.data;
        }
      });
    };

    const onSupplierChange = (value, row) => {
      delete row.application_unit.settle_unit_id;
      data_settleunit_select(value).then((res) => {
        if (res.status == 200)
          row.application_unit.settleunitData = res.data.data?.list;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          let data = [];
          state.employee_list.forEach((e) => {
            let model = JSON.parse(JSON.stringify(e));

            model.application_unit.skssq = parseInt(
              model.application_unit.skssq.replace("-", "")
            );
            data.push(model);
          });

          payrollemployee_editbatch(props.payroll_id, data).then((res) => {
            if (res.status == 200) {
              ElMessage.success(res.data.msg);
              emit("success");
            }
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadIdType,
      onSubmit,
      onSupplierChange,
    };
  },
};
</script>
<style scoped lang="less">
.payroll-edits-box {
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #eeeaea;
  margin-bottom: 20px;
  color: #5c5a5a;

  & > .payroll-edits-box-ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    & .el-form-item__label-wrap {
      margin-left: 0 !important;
    }

    & > div {
      width: 22%;
    }

    & > div:not(:last-child) {
      margin-right: 40px;
    }
  }
}
</style>
